<template>
	<div></div>
</template>

<script>
export default {
	name: 'GetCreateRouteListData',
	setup() {},
}
</script>

<style lang="scss" scoped></style>
